export default {
      id: "models-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#models-usage",
      toString: function () {
        return this.url;
      }
    }